<!--
 * @Author: WLL
 * @Date: 2020-04-16 11:02:52
 * @LastEditors: WLL
 * @LastEditTime: 2020-04-16 22:58:57
 * @Description: 过滤项
 -->
<template>
  <div class="filterItem">
    <span
      class="filterItem_label"
      v-if="label"
      :style="{
        marginRight: `${spacing}px`
      }"
    >
      {{ label }}
    </span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "FilterItem",
  props: {
    label: String,
    spacing: {
      type: Number,
      default: 5
    }
  }
};
</script>

<style lang="less" scoped>
.filterItem {
  display: inline-flex;
  align-items: center;

  .filterItem_label {
    .text("body", "dark");
    flex-shrink: 0;
  }
}
</style>
